import { IConsent } from '../../../../models/Dictionaries';
import { PayloadAction } from '@reduxjs/toolkit';
import { State } from './reducer';

export const setDictConsentsStage1 = (
	state: State,
	action: PayloadAction<IConsent[]>
) => {
	state.consentsStage1 = action.payload;
};

export const setDictConsentsStage2 = (
	state: State,
	action: PayloadAction<IConsent[]>
) => {
	state.consentsStage2 = action.payload;
};

export const setLoaded = (state: State, action: PayloadAction<boolean>) => {
	state.loaded = action.payload;
};
